<div class="dialog-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="header-left">
        <svg class="ai-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                </linearGradient>
            </defs>
            <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-gradient)" stroke="#2C5AA0" stroke-width="1"/>
            <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
        </svg>
        <h2 class="title">AI Settings</h2>
    </div>
</div>
<mat-dialog-content>
    <app-ai-settings
        [aiSettings]="aiSettings"
        (aiSettingsChange)="onAiSettingsChange($event)">
    </app-ai-settings>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-btn">Cancel</button>
    <button mat-button (click)="onSave()" class="primary-btn">Save</button>
</mat-dialog-actions>